var _ellipse, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.16,
    cx: 26.7857,
    cy: 25,
    rx: 26.7857,
    ry: 25,
    fill: "#FF3C00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 31.5217,
    height: 32.2368,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_29_117",
    transform: "matrix(0.0102269 0 0 0.01 -0.011343 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_29_117",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAABPFJREFUeAHtnU2o3UQYhl9/UEEFBX+WLVVUdKeINDORs6nYlbgoYjf+gK6qaCu4KNYuFanuXCm40I0bpS4ViiCoLbhQhLpwV//Ail4VRCmvTHJLbTxfTpo7yXdOznshXDK5me+b50kmkzk5uYB+REAEREAEREAEREAEREAEREAEREAEREAEREAEziPAiB0MeIglnmXE8yuxpFxTzhE7zmvMKq8w4kGWOM4IrvjyeWrLyrpgwNUs8MGKS5h3EB1NbVspMZzhGgZ8NkEZZwV9mtq4ElI4w6Us8NGEZdRSAj7m7bhs6aUw4vXJyzh3PXxjqYUwYN8CGWcY8AUjPtzyEvCJGaveliNGyvWMGSeJCdi3lFIYsIsB/7Qkf5IBt+ZKnjNsN2PNsD1bnJ24jREnzVipzQG7csXLUk8CzYhfzKRL/MwCN2UJtlnJWEJSOBbYxoifzPZF/MaAO3K2r3ddjLiWAd+0JPs3I2a9Axg7jikkpcASgQF/tbTzW85wnZHuOMWdRlQlnhgim7GFVFICHmkRkq4nviOvDiOql4eQUcEZ6RrSzJ8lXmmVEuEz8mLEkwsSO0rg4maDcq17nCHVgbAHlyycgRioVzDZcSduZsSfLUK+HHp6wUtIJSVNC0V8ZbY/4I9RJyRZ4i0zmQFGVPOODE8hlZS6y2wbeb05L+/sZZzhqtbRRj0SSUPgYZeAX82Dot42bPzUvrZRV9p2H67MLqBZIQN2myDOTSmcnYRb99/3N/llX2eJpySk42c7Y0yrsMQhCekopMSh7GdEs0JGHJaQjkIiDjf5ZV+XkM4y0vXTUUjA14zYs5ZL3fZ5AxhHIRHHsp+OK1IhI44Z3biEeDiUEA/qLTElpAWOxyYJ8aDeElNCWuB4bJIQD+otMddGSDXFXuKBbPc2qa4C21rY9tq0FkIY8MLCZ6L6zS6n56wO9iJv7DR5IdUTHv1gz7tbnl92LwqD7wUXT1/IOBOYL14weWOHdRDytDEVMf9o73M2ZfysYvpCSlzPiB8HkxLwQ86H2iYvJPUM1eOpAe8z4Ptsn8+nugq8x4hbjN6nV/FaCOlFxmknCXECb4WVEIuMU7mEOIG3wkqIRcapXEKcwFthJcQi41QuIU7grbASYpFxKpcQJ/BWWAmxyDiVS4gTeCushFhknMolxAm8FVZCLDJO5RLiBN4KKyEWGadyCXECb4WVEIuMU7mEOIG3wkqIRcapXEKcwFthJcQi41QuIU7grbASYpFxKpcQJ/BWWAmxyDiVS4gTeCusr5CA5+Y+lV7iuJXw1MsZcWIuk4gDg7edEXuN4BvcjcsHT2DJAqQ2M+B3g8nDg6fLAncbwckSjw6ewJIFYMTjJo+IuwZPN736lRHfGUmczvl+98Ebs8UArN8Lf9pgcYrARVsM0W13lnjNSCJ95Swl+NiUu6+qm6rPDPt99xFHutHM8Fe8Bze29Jv19wDrfjVd7Lb+byOWq44TC9sescECN2RA3b0KRhxoOUvyfTmzzxc6vfcJeKY7yUx/mfpHRrwjKf975d+7o107mi45wxWS8h8hJd5OTJqcRl3fPFP2d+hXp9yNbdCjm2ozvXmhf5URp9aoG0ttPTL6BbxNRHNbdcaUuHPzjn4/I16a2JLatJepjWPdZzQha10EREAEREAEREAEREAEREAEREAEREAEREAEloDAv72PUo5QVQuTAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox);
export default __webpack_public_path__ + "static/media/icon-box.3db368eee3f3f550e3a3ecab59ead951.svg";
export { ForwardRef as ReactComponent };